import axios from 'axios';
import Cookies from 'js-cookie';
import { FHIR_COOKIE_KEY } from 'src/careflow/ph-core/fhir-client/fhir-base/clients/axios';
import { config } from 'src/config';

const axiosIndexedFhirInstance = axios.create({
  baseURL: config.fhirApiIndexedBaseUrl,
  headers: {
    Authorization: `Bearer ${Cookies.get(FHIR_COOKIE_KEY)}`,
  },
});

if (config.fhirTenantId) {
  axiosIndexedFhirInstance.defaults.headers.common['X-Tenant-Id'] = config.fhirTenantId;
}

axiosIndexedFhirInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosIndexedFhirInstance;
